import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

declare var $: any;
declare var Swiper: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  title = 'UDID';
  private bhashiniContainerObserver: MutationObserver | null = null;

  constructor(public translate: TranslateService) {
    translate.addLangs(['en', 'hi']);
    translate.setDefaultLang('en');
    translate.use('en');
  }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    // The .bhashini-plugin-container is inside the header which is loaded via
    // router-outlet (async). We must wait for it to appear in the DOM before
    // loading the Bhashini script – otherwise pluginContainer.appendChild()
    // throws "Cannot read properties of null".
    this.injectBhashiniWhenReady();
  }

  private injectBhashiniWhenReady(): void {
    // Already injected – nothing to do.
    if (document.querySelector('script[src*="translation-plugin.bhashini.co.in/v3"]')) {
      return;
    }

    // Container already present (fast render path).
    if (document.querySelector('.bhashini-plugin-container')) {
      this.loadBhashiniScript();
      return;
    }

    // Container not yet in DOM: observe body until it appears.
    this.bhashiniContainerObserver = new MutationObserver(() => {
      if (document.querySelector('.bhashini-plugin-container')) {
        this.bhashiniContainerObserver?.disconnect();
        this.bhashiniContainerObserver = null;
        // Guard again in case the observer fired multiple times quickly.
        if (!document.querySelector('script[src*="translation-plugin.bhashini.co.in/v3"]')) {
          this.loadBhashiniScript();
        }
      }
    });
    this.bhashiniContainerObserver.observe(document.body, { childList: true, subtree: true });
  }

  private loadBhashiniScript(): void {
    const script = document.createElement('script');
    script.src = 'https://translation-plugin.bhashini.co.in/v3/website_translation_utility.js';
    // language_order controls the display order in the dropdown.
    // The plugin reads these via document.currentScript.getAttribute(...).
    script.setAttribute('language_order', 'en,hi,ta,te,kn,ml,mr,bn,gu,pa,or,as,ur');
    // Do NOT set async=true here: dynamically injected scripts are already async
    // by default in all browsers. Leaving it unset keeps the execution
    // order predictable relative to the container being ready.
    script.onload = () => {
      // Bhashini v3 opens its dropdown by default on mobile after init.
      // Wait for the plugin to finish rendering, then close it on small screens.
      if (window.innerWidth <= 767) {
        setTimeout(() => {
          const dropdown = document.querySelector('.bhashini-dropdown-content') as HTMLElement;
          if (dropdown) dropdown.style.display = 'none';
        }, 500);
      }
    };
    document.body.appendChild(script);
  }

  ngOnDestroy(): void {
    this.bhashiniContainerObserver?.disconnect();
  }
}
